import(/* webpackMode: "eager" */ "/vercel/path0/app/pricing/page.tsx");
